import PropTypes from 'prop-types';

import RadioButton from '#globalComponents/RadioButton/RadioButton';

import HeaderFilter from './HeaderFilter';

const OPTIONS = [
	{ value: 'all', label: 'Alle' },
	{ value: 'true', label: 'Ja' },
	{ value: 'false', label: 'Nein' },
];

const FILTER_VALUE = { all: undefined, true: true, false: false };

/** Column-header yes/no filter (schema type `yesNo`); "Alle" removes it. */
const YesNoFilterControl = ({ heading, paramKey, value, hint, onChange }) => {
	const selected = value === undefined ? 'all' : String(value);
	return (
		<HeaderFilter label={`Nach „${heading}“ filtern`} active={value !== undefined}>
			<span className="block text-xs text-bgBase-800 mb-1.5">{heading}</span>
			<div className="space-y-1">
				{OPTIONS.map((option) => (
					<RadioButton
						key={option.value}
						id={`hf-${paramKey}-${option.value}`}
						name={`hf-${paramKey}`}
						value={option.value}
						size="sm"
						checked={selected === option.value}
						onChange={() => onChange({ [paramKey]: FILTER_VALUE[option.value] })}
						label={option.label}
					/>
				))}
			</div>
			{hint && <p className="mt-2 text-xs text-bgBase-800">{hint}</p>}
		</HeaderFilter>
	);
};

YesNoFilterControl.propTypes = {
	heading: PropTypes.string.isRequired,
	paramKey: PropTypes.string.isRequired,
	value: PropTypes.bool,
	hint: PropTypes.string,
	onChange: PropTypes.func.isRequired,
};

export default YesNoFilterControl;
